import React, { Component } from "react";
import { Accordion, Table, Segment, Grid } from "semantic-ui-react";
import _ from "lodash";
import getPrintCaseHeader from "./PrintCaseHeader";
import getPersonMinDetail from "./PersonMinDetail";
import SubjectSharedAddressDetail from "./SubjectSharedAddressDetail";

class CommonResidencyReport extends Component {
  state = {
    rows: [],
    activeIndex: 0,
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    const rows = [];
    if (this.props.reportData !== undefined) {
      const comResNodes = _.get(this.props.reportData, "personReport.common");
      if (comResNodes !== undefined && comResNodes.length > 0) {
        _.forEach(comResNodes, (comResNode, index) => {
          const person = _.get(comResNode, "person[0]");
          if (person) {
            rows.push(getPersonMinDetail(person, index, this.props));
            const subject = _.get(comResNode, "subject[0]");
            rows.push(
              <SubjectSharedAddressDetail
                key={`com_sub_${index}`}
                index={index}
                node={subject}
                {...this.props}
              />
            );
          }
        });
      }
      if (rows.length === 0) {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={100}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>{getPrintCaseHeader(this.props)}</Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Accordion fluid styled>
                <Table>
                  <Table.Body>
                    <Table.Row>
                      <Table.HeaderCell
                        className="report-section-header"
                        colSpan={6}
                      >
                        Known Common Residency
                      </Table.HeaderCell>
                    </Table.Row>
                    {rows}
                  </Table.Body>
                </Table>
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default CommonResidencyReport;



// WEBPACK FOOTER //
// ./src/components/reports/CommonResidencyReport.js